import { action } from 'satcheljs/lib/legacy';
export default action('updateSubject')(function updateSubject(viewState, subject) {
    viewState.subject = subject;
    viewState.isDirty = true;
});
//# sourceMappingURL=updateSubject.js.map